import { Navigate, useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import OtherRoutes from './OtherRoutes';
import HotelAiRoutes from './HotelAiRoutes';
import PixelRun from 'views/PixelRun';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    ...HotelAiRoutes,
    { path: '/hotel-recharge', element: <Navigate to="/panel/hotel-recharge" replace /> },
    { path: '/pixel-run', element: <PixelRun /> },
    MainRoutes,
    OtherRoutes
  ]);
}
